/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import './typeform.scss';

function TypeFormEmbed() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    const script = document.createElement('script');
    script.src = 'https://embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  return (
    <div className={`typeform-container ${isMobile ? 'mobile' : ''}`}>
      <div data-tf-live="01J4257HRAQ5SZA9DD6M3KAZ39" />
    </div>
  );
}

export default React.memo(TypeFormEmbed);
